import { takeEvery, put, call } from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';

import { locationChange } from 'actions/appActions';
import { history } from 'store/browserHistory';

function getLocationChangeChannel() {
    return eventChannel(emit => {
        const subscription = history.listen(emit);
        return subscription;
    });
}

function* onLocationChangeListener(location, action) {
    yield put(locationChange({ location, action }));
}

export default function* locationChangeSaga() {
    const locationChannel = yield call(getLocationChangeChannel);

    yield takeEvery(locationChannel, onLocationChangeListener);
}
